module.exports = __webpack_public_path__ + "img/electric.68b142da.svg";